import { Slot } from '@radix-ui/react-slot';

import { cn } from '@utils/cn';

import type { ButtonProps } from '@ui-component-library/components/Button/Button.types';

import { buttonVariants } from './Button.styles';

function Button({
  className,
  variant,
  fullWidth,
  size,
  asChild = false,
  label,
  tabIndex = 0,
  ...props
}: ButtonProps) {
  const Component = asChild ? Slot : 'button';

  if (label) {
    console.error(
      `The "label" with value "${label}" prop for Button is deprecated. Please use the "children" prop instead.`
    );
  }

  return (
    <Component
      data-slot="button"
      className={cn(buttonVariants({ variant, fullWidth, size }), className)}
      tabIndex={tabIndex}
      {...props}
    />
  );
}
export { Button, buttonVariants };
